import React, { Component } from 'react';
import { connect } from 'react-redux';
import { defineMessages } from 'react-intl';
import styled, { css } from 'styled-components';

import { getMessage } from '../../reducers/i18n';
import { changeQty } from '../../actions/cart';
import { defaultQty } from '../../reducers/initialState';

defineMessages({
    FabricLengthSelectionLabel: {
        id: 'SEWPAT_LENGTH_SELECTION_LABEL',
        description: 'Label of the sewpat qty selection form element.',
        defaultMessage: 'Stück',
    },
    FabricLengthSelectionTitle: {
        id: 'SEWPAT_LENGTH_SELECTION_TITLE',
        description: 'Help text of the sewpat qty selection form element.',
        defaultMessage: 'Anzahl gewünschter Schnoffe mit diesem Muster.',
    },
    FabricLengthSelectionHelp: {
        id: 'SEWPAT_LENGTH_SELECTION_HELP',
        description: 'Help text of the fabric length selection form element.',
        defaultMessage: 'Anzahl gewünschter Schnoffe mit diesem Motiv.',
    },
    FabricLengthSelectionError: {
        id: 'SEWPAT_LENGTH_SELECTION_ERROR',
        description: 'Error message of the fabric length selection form element.',
        defaultMessage: 'Oops, so geht das leider nicht. Richtig: Zahl der gewünschten Nähpakete als ganze Zahl.',
    },

});


/**
 * Fabric selection component.
 */
class NumberInput extends Component {

    state = {
        error: false,
        value: defaultQty,
    };
    handleChange = event => {
        if (event.target.type === 'number') {
            this.props.changeQty(parseInt(event.target.value, 10),
                event.target.type,
                !event.target.validity.valid,
            );
        }
        else {
            this.props.changeQty(parseInt(event.target.value, 10),
                event.target.type,
            );
        }
    };

    render() {
        const StyledThing = styled.div`
            margin: ${props => props.theme.space[9]} ${
            props => props.theme.space[4]} ${props => props.theme.space[3]} 0;
        `;

        const normalBorder = css`1px solid ${
            props => props.theme.palette.common.minBlack}`;

        const StyledInput = styled.input`
            text-align: center;
            max-width: ${props => props.theme.space[14]};
            border: ${normalBorder};
            padding: ${props => props.theme.space[1]};
          `;

        return (
            <StyledThing>
                <StyledInput
                    aria-label='fabrics'
                    id={this.props.fieldLabel}
                    label={this.props.fieldLabel}
                    type='number'
                    onChange={this.handleChange}
                    defaultValue={defaultQty}
                    min='1'
                    max='99'
                    step='1'
                    title={this.props.fieldTitle}
                    required
                />
            </StyledThing>
        );
    }
}


const mapDispatchToProps = dispatch => (
    {
        changeQty: (value, type, error) => dispatch(changeQty(value,
            type,
            error,
        )),
    }
);

const mapStateToProps = state => (
    {
        lengthUnit: getMessage(state, 'LENGTH_UNIT'),
        fieldLabel: getMessage(state, 'SEWPAT_LENGTH_SELECTION_LABEL'),
        fieldTitle: getMessage(state, 'SEWPAT_LENGTH_SELECTION_TITLE'),
        fieldHelp: getMessage(state, 'SEWPAT_LENGTH_SELECTION_HELP'),
    }
);

export default connect(mapStateToProps, mapDispatchToProps)(NumberInput);



// WEBPACK FOOTER //
// ./src/components/addtocart/NumberInput.js